import { Outlet } from 'react-router-dom';
import { BluetoothContextProvider } from '../integrations/lavva/modules/device-add/context';

export const BluetoothLayout: React.FC = () => (
  <BluetoothContextProvider>
    <Outlet />
  </BluetoothContextProvider>
);
